export enum ProcessedStatus {
  All = 'All',
  Some = 'Some',
  None = 'None',
}
